import { useState,useEffect } from "react";
import { useParams,useLocation,Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Heading from "../component/ui/Heading.js";
import Loader from "../component/ui/Loader.js";
import ThumbnailCard from "../component/ThumbnailCard/ThumbnailCard.js";
import MediaMainBG from "../component/MediaMainBG/MediaMainBG.js";
import PreviewImage from "../component/previews/PreviewImage.js";
import Button from "../component/ui/Button.js";
import { skipToken } from "@reduxjs/toolkit/query";


export default function AllVideo() {
  const { id } = useParams();
  const title = id;
  const videos = useSelector((state) => state.video.byKey[title] || []);
  let coverImage = null;
  if (Array.isArray(videos.video)) {
    for (const vid of videos.video) {
      if (Array.isArray(vid.categories)) {
        for (const cat of vid.categories) {
          if (
            cat.name &&
            (cat.name === (videos.title || title)) &&
            cat.coverImage
          ) {
            coverImage = cat.coverImage;
            break;
          }
        }
        if (coverImage) break; 
      }
    }
  }
  return (
    <div className="flex h-full">
      <div className="space-y-8 flex-1 p-8">
        <Heading>
          {videos.title || "Categorie"}
        </Heading>
        <MediaMainBG type={videos.title} coverImage={coverImage} />
        
<div className="flex flex-wrap gap-6 justify-start content-start">
          {videos.video.map((video) => (
            <div
              key={video.id}
              style={{ flexBasis: 320 }}
              className="block flex-shrink-0 rounded-lg overflow-x-hidden max-w-[350px] w-full"
            >
              <Link
                to={`/videos/${video.id}`}
                state={{ video: video }}
                className="block"
                style={{ height: 200 }}
              >
                <PreviewImage media={video} type={'tv'} hud={true} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
